export default "__VITE_ASSET__3R31bmMz__"